import 'reflect-metadata';
import { Service } from 'typedi';
import type { SearchApiDocument } from '../../../../api/model/response/documents/SearchResult';
import type { CardTypeStrategyData } from '../../types/card-strategy-data.type';
import { StrategyBuilder } from '../../StrategyBuilder';
import { CardStrategyService } from '../../CardStrategyService';

@Service({ id: 'apcPublicCardStrategyService' })
export class ApcPublicCardStrategyBuilder extends StrategyBuilder<CardStrategyService> {
  build(details: CardTypeStrategyData): CardStrategyService {
      return new ApcPublicCardStrategyService(details);
  }
}

export class ApcPublicCardStrategyService extends CardStrategyService {
  details;
  constructor(details: CardTypeStrategyData) {
      super();
      this.details = details;
  }

  productCardSources = ['ECAT_BSL', 'ECAT_BSL_SUB', 'NAV_PES', 'FAMILY_PES', 'OFFER_PES', 'OFFER_PROMOTED'];

  makeCard(doc: SearchApiDocument): string {
      if (this.productCardSources.includes(doc.source)) {
        return 'uiaas-search-result-product-card-apc';
      }else if (doc.source === 'BSL_DOC'){
        return 'uiaas-search-result-document-v1';
      } else {
        return 'uiaas-search-result-basic-v2';
      }
  }

  getCardProps(
    doc: SearchApiDocument,
    params: Record<string, string>
  ): Record<string, string> {
      if (this.details?.params) return this.details.params;
      return {};
  }
}
